(function () {
  function readScroll() {
    if (window.lenis && typeof window.lenis.scroll === 'number') return window.lenis.scroll;
    var page = document.querySelector('.page-wrapper');
    if (page && page.scrollHeight > page.clientHeight + 2) return page.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function writeScroll(value) {
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(value, { immediate: true });
      return;
    }
    var page = document.querySelector('.page-wrapper');
    if (page && page.scrollHeight > page.clientHeight + 2) {
      page.scrollTop = value;
      return;
    }
    window.scrollTo(0, value);
  }

  function init(root) {
    if (root.dataset.wbsFaqReady === 'true') return;
    root.dataset.wbsFaqReady = 'true';

    var groups = Array.from(root.querySelectorAll('[data-wbs-faq-tab]'));
    var items = Array.from(root.querySelectorAll('[data-wbs-faq]'));
    var list = root.querySelector('.wbs-faq__list');
    if (!items.length && !groups.length) return;

    function closeItem(item) {
      item.classList.remove('is-open');
      var button = item.querySelector('[data-wbs-faq-button]');
      if (button) button.setAttribute('aria-expanded', 'false');
      var anim = panel(item);
      if (anim) anim.hidden = true;
    }

    function selectGroup(id) {
      groups.forEach(function (tab) {
        var on = tab.getAttribute('data-wbs-faq-tab') === id;
        tab.classList.toggle('is-selected', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && list) list.setAttribute('aria-labelledby', tab.id);
      });

      items.forEach(function (item) {
        var on = item.getAttribute('data-wbs-faq-group') === id;
        if (!on) closeItem(item);
        item.hidden = !on;
      });
    }

    groups.forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectGroup(tab.getAttribute('data-wbs-faq-tab'));
      });
    });

    root.addEventListener('shopify:block:select', function (event) {
      var tab = event.target.closest('[data-wbs-faq-tab]');
      if (tab) {
        selectGroup(tab.getAttribute('data-wbs-faq-tab'));
        return;
      }
      var item = event.target.closest('[data-wbs-faq]');
      if (item) selectGroup(item.getAttribute('data-wbs-faq-group'));
    });

    if (groups.length) {
      var selected = root.querySelector('[data-wbs-faq-tab].is-selected') || groups[0];
      selectGroup(selected.getAttribute('data-wbs-faq-tab'));
    }

    function panel(item) {
      return item.querySelector('[data-wbs-faq-panel]');
    }

    function hidePanel(item) {
      var anim = panel(item);
      if (!anim || item.classList.contains('is-open')) return;
      var done = function (event) {
        if (event && event.target !== anim) return;
        if (event && event.propertyName !== 'max-height' && event.propertyName !== 'opacity') return;
        anim.hidden = true;
        anim.removeEventListener('transitionend', done);
      };
      anim.addEventListener('transitionend', done);
      window.setTimeout(function () {
        if (!item.classList.contains('is-open')) anim.hidden = true;
      }, 480);
    }

    items.forEach(function (item) {
      var anim = panel(item);
      if (anim && !item.classList.contains('is-open')) anim.hidden = true;
    });

    var pinTimer = 0;
    var pinStop = 0;

    function hold(summary, anchorTop) {
      if (pinTimer) window.clearInterval(pinTimer);
      if (pinStop) window.clearTimeout(pinStop);
      var pin = function () {
        var drift = summary.getBoundingClientRect().top - anchorTop;
        if (Math.abs(drift) > 0.5) writeScroll(readScroll() + drift);
      };
      pin();
      pinTimer = window.setInterval(pin, 16);
      pinStop = window.setTimeout(function () {
        window.clearInterval(pinTimer);
        pinTimer = 0;
        pin();
      }, 800);
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-wbs-faq-button]');
      if (!button) return;

      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        var anchorTop = button.getBoundingClientRect().top;

        items.forEach(function (other) {
          var open = other.classList.contains('is-open');
          other.classList.remove('is-open');
          var otherButton = other.querySelector('[data-wbs-faq-button]');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
          if (open) hidePanel(other);
        });

        if (!wasOpen) {
          var anim = panel(item);
          if (anim) {
            anim.hidden = false;
            void anim.offsetHeight;
          }
          window.requestAnimationFrame(function () {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          });
        }

        hold(button, anchorTop);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-wbs-faq-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wbs-faq-root]');
    if (!root && event.target.matches && event.target.matches('[data-wbs-faq-root]')) root = event.target;
    if (root) init(root);
  });
})();
